import { useState } from "react";
import { Link } from "react-router-dom";

const logoUrl = "https://public.readdy.ai/ai/img_res/195817ff-c016-4391-b195-c404bb90dcaf.png";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleNewsletterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      const body = new URLSearchParams({ email });
      await fetch("https://readdy.ai/api/form/d73n0m4prit363gl0bh0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="bg-provider-bg mx-4 mb-4 rounded-3xl text-white/80 mt-16">
      <div className="max-w-screen-xl mx-auto px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Newsletter */}
          <div className="md:col-span-2">
            <img src={logoUrl} alt="TSUGITE" className="h-8 w-auto object-contain mb-4 opacity-90" />
            <p className="font-display text-3xl font-light text-white leading-snug mb-2">
              TSUGITEの<br />
              <span className="italic">ニュースレター</span>
            </p>
            <p className="text-sm text-white/60 mb-6 font-sans">
              新着講座・特集・職人からのメッセージをお届けします。
            </p>
            {submitted ? (
              <p className="text-gold font-sans text-sm animate-fade-in">ご登録ありがとうございます。</p>
            ) : (
              <form
                data-readdy-form
                onSubmit={handleNewsletterSubmit}
                className="flex gap-2"
              >
                <input
                  type="email"
                  name="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="メールアドレスを入力"
                  className="flex-1 bg-transparent border-b border-white/30 focus:border-gold outline-none text-white placeholder-white/40 text-sm py-2 font-sans transition-colors"
                />
                <button
                  type="submit"
                  disabled={submitting}
                  className="bg-white text-deep-green px-5 py-2 rounded-full text-sm font-sans font-medium whitespace-nowrap cursor-pointer hover:bg-ivory transition-colors"
                >
                  {submitting ? "送信中..." : "登録する →"}
                </button>
              </form>
            )}
          </div>

          {/* Navigation */}
          <div>
            <p className="text-white/50 text-xs uppercase tracking-widest mb-4 font-sans">ナビゲーション</p>
            <ul className="flex flex-col gap-3">
              {[
                { label: "事業者を探す", href: "/providers" },
                { label: "カテゴリ一覧", href: "/categories" },
                { label: "講座一覧", href: "/courses" },
                { label: "教材一覧", href: "/materials" },
                { label: "よくある質問", href: "/faq" },
                { label: "お問い合わせ", href: "/contact" },
              ].map((item) => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    className="text-sm text-white/70 hover:text-white transition-colors underline underline-offset-4 decoration-white/20 hover:decoration-white cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="text-white/50 text-xs uppercase tracking-widest mb-4 font-sans">出店について</p>
            <ul className="flex flex-col gap-3">
              {[
                { label: "無料で出店する", href: "/register" },
                { label: "プラン・料金", href: "/pricing" },
                { label: "出店ガイド", href: "/guide" },
                { label: "利用規約", href: "/terms" },
                { label: "プライバシーポリシー", href: "/privacy" },
              ].map((item) => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    className="text-sm text-white/70 hover:text-white transition-colors underline underline-offset-4 decoration-white/20 hover:decoration-white cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            {["ri-instagram-line", "ri-twitter-x-line", "ri-youtube-line"].map((icon) => (
              <a key={icon} href="#" rel="nofollow" className="w-8 h-8 flex items-center justify-center text-white/50 hover:text-white transition-colors cursor-pointer">
                <i className={`${icon} text-lg`} />
              </a>
            ))}
          </div>
          <p className="text-white/40 text-xs font-sans">© 2025 TSUGITE. All rights reserved.</p>
          <div className="flex gap-4">
            <Link to="/terms" className="text-white/40 text-xs hover:text-white/70 transition-colors cursor-pointer">利用規約</Link>
            <Link to="/privacy" className="text-white/40 text-xs hover:text-white/70 transition-colors cursor-pointer">プライバシーポリシー</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
